import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/imgs/Group-1400.png'
import _imports_1 from '../../assets/imgs/Group-1402.png'


const _withScopeId = n => (_pushScopeId("data-v-6f86392e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "top white" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "case" }, null, -1))
const _hoisted_4 = {
  class: "h2 heading",
  id: "font-size"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("body", null, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "container",
    style: {"width":"80%","margin-left":"12%"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "faq-drawer__trigger",
        id: "faq-drawer",
        type: "checkbox"
      }),
      /*#__PURE__*/_createElementVNode("label", {
        class: "faq-drawer__title",
        for: "faq-drawer"
      }, "Introduction to eGC "),
      /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content-wrapper" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content" }, [
          /*#__PURE__*/_createElementVNode("iframe", {
            id: "frame",
            width: "65%",
            height: "315",
            padding: "50px",
            src: "https://www.youtube.com/embed/YfUP29oF_Sc",
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          }),
          /*#__PURE__*/_createElementVNode("p", { class: "content-introduction" }, " Introducing Roxe eGC, discounted eGiftCards from merchants you love. ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "faq-drawer__trigger",
        id: "faq-drawer-2",
        type: "checkbox"
      }),
      /*#__PURE__*/_createElementVNode("label", {
        class: "faq-drawer__title",
        for: "faq-drawer-2"
      }, "How to purchase an eGC?"),
      /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content-wrapper" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content" }, " If you are a new user of Roxe App, please make sure to fund your Roxe Wallet before making any purchase. You can use a debit card, credit card, or bank account to add funds into your wallet. After the fund is confirmed, you can use your fund balance to purchase eGC for yourself or send it to anyone as a gift. "),
          /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: _imports_0,
                width: "500"
              })
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "faq-drawer__trigger",
        id: "faq-drawer-3",
        type: "checkbox"
      }),
      /*#__PURE__*/_createElementVNode("label", {
        class: "faq-drawer__title",
        for: "faq-drawer-3"
      }, "How to use an eGC?"),
      /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content-wrapper" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content" }, " Once you have your eGC added in your wallet, simply go to ‘Wallet’ and ‘Scan’ the Roxe QR code at the merchant and enter the total amount and confirm the transaction. In the future version, you can also show your QR code for the merchant to scan and send you a payment request. After the transaction, you will receive the receipt in your email. "),
          /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: _imports_1,
                width: "500"
              })
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "faq-drawer__trigger",
        id: "faq-drawer-4",
        type: "checkbox"
      }),
      /*#__PURE__*/_createElementVNode("label", {
        class: "faq-drawer__title",
        for: "faq-drawer-4"
      }, "What is cashback and how can I use it?"),
      /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content-wrapper" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content" }, " You will be earning cashback in your Roxe Wallet whenever you purchase an eGC with cashback promotion or use the balance in the Roxe Wallet to purchase. The eGC cashback rebate varies from different merchants. Today, you can freely use your cashback balance purchasing more eGC or make in-store payment as cash. In the very near future, you will be able to withdraw cashback balance to your bank account or debit card, or send it to other Roxe App users. ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "faq-drawer__trigger",
        id: "faq-drawer-5",
        type: "checkbox"
      }),
      /*#__PURE__*/_createElementVNode("label", {
        class: "faq-drawer__title",
        for: "faq-drawer-5"
      }, "What is my eGC purchase limit?"),
      /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content-wrapper" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content" }, " As of now, we allow each user to purchase up to $500 value of eGC per day across all merchants on the Roxe App. ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "faq-drawer__trigger",
        id: "faq-drawer-6",
        type: "checkbox"
      }),
      /*#__PURE__*/_createElementVNode("label", {
        class: "faq-drawer__title",
        for: "faq-drawer-6"
      }, [
        /*#__PURE__*/_createTextVNode("How to get refund of my unused eGC "),
        /*#__PURE__*/_createElementVNode("br", { class: "responsive" }),
        /*#__PURE__*/_createTextVNode(" balance?")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content-wrapper" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content" }, [
            /*#__PURE__*/_createTextVNode(" First, please note that not all eGC are eligible for refund after purchase. As we are developing an eGC refund function into the App, if today you do not want to use the remaining balance of your eGC, please contact us at "),
            /*#__PURE__*/_createElementVNode("a", {
              href: "mailto:support@roxe.io",
              class: "email-roxe"
            }, "support@roxe.io"),
            /*#__PURE__*/_createTextVNode(" and our team will process that for you. ")
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "faq-drawer__trigger",
        id: "faq-drawer-7",
        type: "checkbox"
      }),
      /*#__PURE__*/_createElementVNode("label", {
        class: "faq-drawer__title",
        for: "faq-drawer-7",
        id: "faq-drawer__title"
      }, [
        /*#__PURE__*/_createTextVNode("What happens if I purchase multiple eGC "),
        /*#__PURE__*/_createElementVNode("br", { class: "responsive" }),
        /*#__PURE__*/_createTextVNode("for the same merchant?")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content-wrapper" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content" }, " For your convenience, we are showing your total eGC balance for each merchant. You can find your purchase history in ‘Wallet’ - ‘Activity’ ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "faq-drawer__trigger",
        id: "faq-drawer-8",
        type: "checkbox"
      }),
      /*#__PURE__*/_createElementVNode("label", {
        class: "faq-drawer__title",
        for: "faq-drawer-8"
      }, [
        /*#__PURE__*/_createTextVNode("What if I cannot use the eGC at the "),
        /*#__PURE__*/_createElementVNode("br", { class: "responsive" }),
        /*#__PURE__*/_createTextVNode("merchant?")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content-wrapper" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content" }, [
            /*#__PURE__*/_createTextVNode(" Please try to reopen the Roxe App and make the payment again. Contact us at "),
            /*#__PURE__*/_createElementVNode("a", {
              href: "mailto:support@roxe.io",
              class: "email-roxe"
            }, "support@roxe.io"),
            /*#__PURE__*/_createTextVNode(" if the issue is still present, and our team will look into it. ")
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "faq-drawer__trigger",
        id: "faq-drawer-9",
        type: "checkbox"
      }),
      /*#__PURE__*/_createElementVNode("label", {
        class: "faq-drawer__title",
        for: "faq-drawer-9"
      }, "Can I use a merchant's eGC at different locations?"),
      /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content-wrapper" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "faq-drawer__content" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content" }, " Each merchant may have different policies, and if so, such policies given in their eGC description along with any applicable eGC limits. Please carefully read their description and confirm that your preferred locations will accept the eGC. ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("hr", { class: "accordion-hr-tag" })
  ])
], -1))
const _hoisted_6 = { class: "grid mb10 max" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Tail = _resolveComponent("Tail")!
  const _directive_trnew = _resolveDirective("trnew")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header, { theme: "white" })
    ]),
    _hoisted_3,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
      _createTextVNode("eGiftCard FAQ")
    ])), [
      [_directive_trnew]
    ]),
    _hoisted_5,
    _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
      [_directive_trnew]
    ]),
    _createVNode(_component_Tail)
  ]))
}